/** @internal */
export const OP_EXTEND_SCOPE = "ExtendScope";
/** @internal */
export const OP_FOLD = "Fold";
/** @internal */
export const OP_FRESH = "Fresh";
/** @internal */
export const OP_FROM_EFFECT = "FromEffect";
/** @internal */
export const OP_SCOPED = "Scoped";
/** @internal */
export const OP_SUSPEND = "Suspend";
/** @internal */
export const OP_PROVIDE = "Provide";
/** @internal */
export const OP_PROVIDE_MERGE = "ProvideMerge";
/** @internal */
export const OP_MERGE_ALL = "MergeAll";
/** @internal */
export const OP_ZIP_WITH = "ZipWith";
//# sourceMappingURL=layer.js.map